export enum PaymentStatus {
    PAID = "paid",
    PENDING = "pending",
    UNPAID = "unpaid",
    REFUND = "refund",
}

export const payment_status_options = Object.values(PaymentStatus); 